module.exports = __webpack_public_path__ + "img/governicon2.90b5af13.svg";